module.exports = __webpack_public_path__ + "img/instagram-line-dark.f92ab92.svg";